<template>
  <div class="container v-content-container tooltip-wrapper popup-wrapper">
    <div class="row tooltip-wrapper">
      <div class="col-xs-12">
        <h1>
          <span v-if="selectedBookingId != null">
            {{ noDataExist ? "Event booking" : bookingName }}
          </span>
          <span v-else-if="!loading">
            {{ $label("booking.new_booking", "New Booking") }}
          </span>
        </h1>
      </div>
    </div>

    <div class="row mt-8">
      <div class="col-xs-12">&nbsp;</div>
    </div>

    <error404 v-if="noDataExist" />

    <template v-else>
      <new-customer-modal
        :showModal="showAddCustomerModal"
        @close="closeAddCustomerModal"
        @onSuccess="onSelectCustomer"
      />

      <div v-show="loading" class="row">
        <div class="col-xs-12">
          <view-loader
            margin-top-pixels="15"
            border-color="primary"
          ></view-loader>
        </div>
      </div>

      <div class="row"><div class="col-xs-12">&nbsp;</div></div>

      <!-- Tab panes -->
      <div v-show="!loading" class="tab-content tooltip-wrapper">
        <div id="form-booking-data">
          <div class="tab-pane active" id="booking-data">
            <div class="row">
              <div class="col-sm-6">
                <h2>
                  <i class="fa fa-fw fa-lg fa-dot-circle-o"></i>
                  <span id="booking-header">
                    {{ $label("booking.who", "Who") }}</span
                  >
                </h2>
                <p></p>
                <div class="v-form-partial">
                  <div class="v-form">
                    <fieldset>
                      <div class="row">
                        <section class="col col-12">
                          <label class="label">{{
                            $label("booking.customer", "Customer")
                          }}</label>
                          <div class="row">
                            <div class="col col-10">
                              <searchable-select
                                v-model="selectedBooking.customer"
                                :searchResult="customers"
                                :placeholder="
                                  $label(
                                    'booking.customer_search',
                                    'Search customer'
                                  )
                                "
                                @change="onSearchChange"
                              >
                              </searchable-select>
                            </div>
                            <div class="col col-2">
                              <button
                                type="button"
                                class="btn btn-primary user-plus-button"
                                @click="openAddCustomerModal"
                              >
                                <i class="fa fa-user-plus"></i>
                              </button>
                            </div>
                          </div>
                          <p v-if="hasError('customer_id')" class="text-danger">
                            {{ getError("customer_id") }}
                          </p>
                        </section>
                      </div>

                      <!-- BEGIN Remarks -->
                      <section>
                        <label class="label">{{
                          $label("booking.remarks", "Remarks")
                        }}</label>
                        <label class="textarea">
                          <i class="icon-append fa fa-comment"></i>
                          <textarea
                            v-model="selectedBooking.remarks"
                            :disabled="updating"
                            id="booking-note"
                            rows="3"
                          >
                          </textarea>
                        </label>
                      </section>
                      <!-- END Remarks -->
                    </fieldset>
                  </div>
                </div>
              </div>

              <div class="col-sm-6 tooltip-wrapper">
                <h2>
                  <i class="fa fa-fw fa-lg fa-calendar"></i>
                  {{ $label("booking.event", "Event") }}
                </h2>
                <p></p>
                <div class="v-form-partial">
                  <div class="v-form">
                    <fieldset>
                      <div class="row">
                        <!-- BEGIN Event -->
                        <section class="col col-12">
                          <label class="label">{{
                            $label("booking.event", "Event")
                          }}</label>
                          <label class="select">
                            <select
                              id="booking-event"
                              v-model="selectedBooking.event_id"
                              :disabled="updating"
                            >
                              <option
                                v-for="event in events"
                                :key="event.id"
                                :value="event.id"
                                >{{ event.name }}</option
                              >
                            </select>
                            <i></i>
                          </label>
                          <p
                            v-if="
                              hasError('event_id') ||
                                hasError('events.0.event_id')
                            "
                            class="text-danger"
                            style="word-break: break-all"
                          >
                            {{
                              getError("event_id") ||
                                getError("events.0.event_id")
                            }}
                          </p>
                        </section>
                        <!-- End Event -->
                      </div>
                      <div class="row">
                        <section class="col-9 col">
                          <label class="label">
                            {{ $label("booking.price", "Price") }}
                          </label>
                          <label class="select">
                            <select
                              id="booking-price"
                              v-model="selectedBooking.price"
                              :disabled="selectedBooking.use_manual_price"
                            >
                              <option
                                v-for="price in prices"
                                :key="price.id"
                                :value="price.id"
                                >{{ price.name }}</option
                              >
                            </select>
                            <i></i>
                          </label>
                        </section>

                        <section class="col-3 col">
                          <label class="label">
                            {{ $label("booking.discount", "Discount") }}
                          </label>
                          <label class="select">
                            <select
                              id="booking-discount"
                              v-model="selectedBooking.discount_id"
                              :disabled="selectedBooking.use_manual_price"
                            >
                              <option value="">-</option>
                              <option
                                v-for="discount in discounts"
                                :key="discount.id"
                                :value="discount.id"
                                >{{ discount.value }}</option
                              >
                            </select>
                            <i></i>
                          </label>
                        </section>
                      </div>

                      <div class="row">
                        <section class="col-4 col">
                          <label class="label">
                            {{ $label("booking.oversteer", "Oversteer") }}
                          </label>
                          <label class="checkbox">
                            <input
                              type="checkbox"
                              id="booking-use-manual-price"
                              v-model="selectedBooking.use_manual_price"
                            />
                            {{ $label("booking.manual_price", "Manual price") }}
                            <i></i>
                          </label>
                          <p
                            v-if="
                              hasError('use_manual_price') ||
                                hasError('events.0.use_manual_price')
                            "
                            class="text-danger"
                          >
                            {{
                              getError("use_manual_price") ||
                                getError("events.0.use_manual_price")
                            }}
                          </p>
                        </section>

                        <section class="col-4 col">
                          <label class="label">
                            {{ $label("booking.vat", "Vat").toUpperCase() }}
                          </label>
                          <label class="input">
                            <label class="select">
                              <select
                                id="booking-manual-price-vat"
                                v-model="selectedBooking.manual_price_vat_id"
                                :disabled="
                                  updating || !selectedBooking.use_manual_price
                                "
                              >
                                <option
                                  v-for="vat in vats"
                                  :value="vat.id"
                                  :key="vat.id"
                                >
                                  {{ vat.name }}
                                </option>
                              </select>
                              <i></i>
                            </label>
                          </label>
                        </section>

                        <section class="col-4 col">
                          <label class="label">
                            {{ $label("booking.total_price", "Total price ") }}
                            (gross)
                          </label>
                          <label class="input">
                            <i class="icon-append fa fa-euro"></i>
                            <input
                              id="booking-manual-price-gross"
                              v-model="
                                selectedBooking.manual_price_amount_gross
                              "
                              type="number"
                              name="total_price"
                              :readonly="!selectedBooking.use_manual_price"
                              :class="{
                                'is-disabled': !selectedBooking.use_manual_price
                              }"
                            />
                          </label>
                          <p
                            v-if="
                              hasError('events.0.manual_price_amount_gross')
                            "
                            class="text-danger"
                          >
                            {{ getError("events.0.manual_price_amount_gross") }}
                          </p>
                        </section>
                      </div>

                      <div class="row">
                        <section class="col-4 col">
                          <label class="label">
                            {{ $label("booking.net", "Net") }}
                          </label>
                          <label class="input">
                            <i class="icon-append fa fa-euro"></i>
                            <input
                              type="number"
                              id="booking-amount-net"
                              readonly
                              :class="{
                                'is-disabled': true
                              }"
                              :value="selectedBooking.amount_net"
                            />
                          </label>
                        </section>

                        <section class="col-4 col">
                          <label class="label">
                            {{ $label("booking.vat", "Vat").toUpperCase() }}
                          </label>
                          <label class="input">
                            <i class="icon-append fa fa-euro"></i>
                            <input
                              type="number"
                              readonly
                              :class="{
                                'is-disabled': true
                              }"
                              id="booking-vat"
                              :value="selectedBooking.vat"
                            />
                          </label>
                        </section>

                        <section class="col-4 col">
                          <label class="label">
                            {{ $label("booking.gross", "Gross") }}
                            <a href="#"><i class="fa fa-info-circle"></i></a>
                          </label>
                          <label class="input">
                            <i class="icon-append fa fa-euro"></i>
                            <input
                              type="number"
                              id="booking-amount-gross"
                              readonly
                              :class="{
                                'is-disabled': true
                              }"
                              v-model="selectedBooking.amount_gross"
                            />
                          </label>
                        </section>
                      </div>

                      <div class="row">
                        <!-- BEGIN payment method -->
                        <section class="col col-6">
                          <label class="label">{{
                            $label("booking.payment_method", "Payment Method")
                          }}</label>
                          <label class="select">
                            <select
                              id="booking-payment-method"
                              v-model="selectedBooking.paymentMethod"
                              :disabled="updating"
                            >
                              <option
                                v-for="paymentType in paymentTypes"
                                :value="paymentType.id"
                                :key="paymentType.id"
                              >
                                {{ paymentType.slug }}
                              </option>
                            </select>
                            <i></i>
                          </label>
                          <p
                            v-if="hasError('payment_type_id')"
                            class="text-danger"
                          >
                            {{ getError("payment_type_id") }}
                          </p>
                        </section>
                        <!-- END payment method -->
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>

            <div class="row"><div class="col-xs-12"></div></div>
          </div>

          <hr />

          <div class="row">
            <div class="col-xs-12 text-center">
              <info-button
                class="mr-1"
                :class="{ 'is-disabled': updating }"
                id="booking-save-button"
                icon="fa fa-fw fa-lg fa-save"
                :text="$label('booking.save', 'Save')"
                @click.native="createOrUpdateBooking"
              >
              </info-button>

              <warning-button
                class="mr-1"
                :class="{ 'is-disabled': updating }"
                id="cancel-booking-button"
                icon="fa fa-fw fa-lg fa-times"
                :text="$label('common.cancel', 'Cancel')"
                @click.native="cancelBooking"
              >
              </warning-button>
            </div>
          </div>
        </div>
      </div>

      <div class="row"><div class="col-xs-12">&nbsp;</div></div>

      <div class="row mb-4">
        <div class="col-xs-12"></div>
      </div>
    </template>
  </div>
</template>

<script>
import Api from "@/api";
import swal from "sweetalert";
import FormErrorsMixin from "@/mixins/FormErrors";

import "vue-swatches/dist/vue-swatches.css";

import ViewLoader from "@/components/Common/ViewLoader";
import InfoButton from "@/components/Common/Buttons/InfoButton";
import WarningButton from "@/components/Common/Buttons/WarningButton";
import NewCustomerModal from "@/components/Customers/Customer/NewCustomerModal";
import SearchableSelect from "@/components/Common/Select/SearchableSelect";
import Error404 from "@/components/Common/Error404";

import "vue-slider-component/theme/default.css";

export default {
  name: "BookingEventDetail",

  mixins: [FormErrorsMixin],

  components: {
    ViewLoader,
    InfoButton,
    WarningButton,
    NewCustomerModal,
    SearchableSelect,
    Error404
  },

  data() {
    return {
      loading: false,
      updating: false,
      noDataExist: false,
      bookingName: null,
      showAddCustomerModal: false,
      selectedBooking: {
        paymentMethod: null,
        remarks: null,
        customer: null,
        event_id: null,
        price: null,
        discount_id: "",
        amount_net: null,
        amount_gross: null,
        vat: null,
        manual_price_vat_id: null,
        manual_price_amount_gross: null,
        use_manual_price: false
      },
      selectedBookingId: null,
      paymentTypes: [],
      discounts: [],
      customers: [],
      customerList: [],
      events: [],
      vats: [],
      prices: [],
      validatedInputs: [
        "customer_id",
        "payment_type_id",
        "event_id",
        "starts_at",
        "ends_at",
        "use_manual_price",
        "events.0.customer_id",
        "events.0.payment_type_id",
        "events.0.event_id",
        "events.0.starts_at",
        "events.0.ends_at",
        "events.0.use_manual_price",
        "events.0.manual_price_amount_gross"
      ],
      debounce: null
    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.selectedBookingId = vm.$route.params.booking_id;
      if (
        typeof vm.selectedBookingId !== "undefined" &&
        vm.selectedBookingId !== null
      ) {
        vm.getEventBooking();
        if (vm.$route.query.customer_created) {
          swal("Success!", "The Customer was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
        if (vm.$route.query.booking_created) {
          swal("Success!", "The Booking was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
      }
      vm.getEvents();
      vm.getVats();
      vm.getPaymentTypes();
      vm.getDiscounts();
    });
  },

  beforeRouteUpdate(to, from, next) {
    if (
      typeof this.selectedBookingId !== "undefined" &&
      this.selectedBookingId !== null
    ) {
      this.getEventBooking();
    }
    this.getEvents();
    this.getVats();
    this.getPaymentTypes();
    this.getDiscounts();
    next();
  },

  mounted: function() {
    this.getEvents();
    this.getVats();
    this.getPaymentTypes();
    this.getDiscounts();
  },

  watch: {
    "selectedBooking.event_id": function(newState) {
      if (!newState) return;
      this.prices = [];
      this.getEventPrices(newState, prices => {
        this.prices = prices.map(price => ({
          id: price.id,
          name: `${price.name} - ${price.amount_gross} EUR`
        }));
        const selectedPrice = this.prices.find(
          price => price.id === this.selectedBooking.price
        );
        if (!selectedPrice) {
          this.selectedBooking.price =
            this.prices.length > 0 ? this.prices[0].id : "null";
        }
      });
    }
  },

  methods: {
    cancelBooking() {
      this.$router.push({ name: "BookingEvents" });
    },

    createOrUpdateBooking() {
      if (this.selectedBookingId == null) {
        this.createBooking();
      } else {
        this.updateBooking();
      }
    },

    generateSavingData(type) {
      if (type === "create") {
        return {
          customer_id: this.selectedBooking.customer?.id,
          payment_type_id: this.selectedBooking.paymentMethod,
          internal_note: this.selectedBooking.remarks,
          events: [
            {
              event_id: this.selectedBooking.event_id,
              discount_id: this.selectedBooking.discount_id,
              price_id: this.selectedBooking.price,
              use_manual_price: this.selectedBooking.use_manual_price,
              manual_price_amount_gross: this.selectedBooking
                .manual_price_amount_gross,
              manual_price_vat_id: this.selectedBooking.manual_price_vat_id
            }
          ]
        };
      } else {
        return {
          customer_id: this.selectedBooking.customer?.id,
          payment_type_id: this.selectedBooking.paymentMethod,
          internal_note: this.selectedBooking.remarks,
          event_id: this.selectedBooking.event_id,
          discount_id: this.selectedBooking.discount_id,
          price_id: this.selectedBooking.price,
          use_manual_price: this.selectedBooking.use_manual_price,
          manual_price_amount_gross: this.selectedBooking
            .manual_price_amount_gross,
          manual_price_vat_id: this.selectedBooking.manual_price_vat_id
        };
      }
    },

    getEventBooking() {
      this.loading = true;
      const endpoint = this.$partnerEndpoint(
        `bookings/events/${this.selectedBookingId}`
      );

      Api()
        .get(endpoint)
        .then(response => {
          const eventBooking = response.data.data;
          const customer = eventBooking.booking.customer;

          this.selectedBooking.customer = {
            id: customer.id,
            name: `${customer.last_name} ${customer.first_name}`
          };
          this.bookingName = "Event Booking";
          this.selectedBooking.paymentMethod =
            eventBooking.booking.payment_type.id;
          this.selectedBooking.remarks = eventBooking.booking.internal_note;
          this.selectedBooking.amount_net =
            eventBooking.booking.total_price.amount_net;
          this.selectedBooking.amount_gross =
            eventBooking.booking.total_price.amount_gross;
          this.selectedBooking.vat =
            eventBooking.booking.total_price.vat_amount;
          this.selectedBooking.event_id = eventBooking.event.id;
          this.selectedBooking.discount_id = eventBooking.discount
            ? eventBooking.discount.id
            : "";

          const eventPrice = eventBooking.event_price;
          if (eventPrice.type === "manual") {
            this.selectedBooking.use_manual_price = true;
            this.selectedBooking.manual_price_vat_id = eventPrice.vat
              ? eventPrice.vat.id
              : null;
            this.selectedBooking.manual_price_amount_gross =
              eventPrice.amount_gross;
          } else {
            this.selectedBooking.price = eventPrice.id;
          }
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.noDataExist = true;
          }
          this.storeErrors(error.response.data.errors);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    createBooking() {
      if (this.updating) {
        return;
      }

      this.resetErrors();
      this.updating = true;
      const endpoint = this.$partnerEndpoint("bookings/events");
      const bookingInfo = this.generateSavingData("create");

      Api()
        .post(endpoint, bookingInfo)
        .then(response => {
          this.selectedBookingId = response.data.data.id;
          this.$router.push({
            name: "BookingEventDetails",
            params: { booking_id: this.selectedBookingId },
            query: { booking_created: true }
          });
        })
        .catch(error => {
          this.storeErrors(error.response.data.errors);
        })
        .finally(() => {
          this.updating = false;
        });
    },

    updateBooking() {
      if (this.loading || this.updating) {
        return;
      }

      this.resetErrors();
      this.updating = true;
      const endpoint = this.$partnerEndpoint(
        `bookings/events/${this.selectedBookingId}`
      );
      const bookingInfo = this.generateSavingData("update");

      Api()
        .put(endpoint, bookingInfo)
        .then(() => {
          this.getEventBooking();
          swal({
            title: "Success!",
            text: "The booking was updated.",
            icon: "success"
          });
        })
        .catch(error => {
          this.storeErrors(error.response.data.errors);
        })
        .finally(() => {
          this.updating = false;
        });
    },

    onSearchChange(query) {
      if (query.length >= 2) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          this.getCustomers(query);
        }, 600);
      } else {
        this.customers = [];
      }
    },

    getCustomers(query = "") {
      const endpoint = this.$partnerEndpoint("customers");

      return Api()
        .get(endpoint, {
          params: {
            search: query
          }
        })
        .then(response => {
          this.customers = response.data.data.map(
            ({ id, first_name, last_name }) => ({
              id,
              name: `${last_name} ${first_name}`
            })
          );
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    getEvents() {
      const endpoint = this.$partnerEndpoint("events");

      Api()
        .get(endpoint, {
          params: {
            timeframe: "current"
          }
        })
        .then(response => {
          this.events = response.data.data;
          const selectedEvent = this.$route.query.event_id
            ? this.events.find(
                event => event.id === parseInt(this.$route.query.event_id, 10)
              )
            : null;
          if (this.$route.query.event_id) {
            if (selectedEvent) {
              this.selectedBooking.event_id = selectedEvent.id;
            }
          } else {
            if (!this.selectedBookingId && this.events.length > 0) {
              this.selectedBooking.event_id = this.events[0].id;
            }
          }
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    getPaymentTypes() {
      const endpoint = this.$partnerEndpoint("payment-types");

      Api()
        .get(endpoint)
        .then(response => {
          this.paymentTypes = response.data.data;
          if (!this.selectedBookingId && this.paymentTypes.length > 0) {
            this.selectedBooking.paymentMethod = this.paymentTypes[0].id;
          }
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    getDiscounts() {
      const endpoint = this.$partnerEndpoint("discounts");

      Api()
        .get(endpoint)
        .then(response => {
          this.discounts = response.data.data;
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    getVats() {
      const endpoint = this.$partnerEndpoint("vats");

      Api()
        .get(endpoint)
        .then(response => {
          this.vats = response.data.data;
          if (!this.selectedBookingId && this.vats.length > 0) {
            this.selectedBooking.manual_price_vat_id = this.vats[0].id;
          }
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    getEventPrices(eventId, successCallback) {
      const endpoint = this.$partnerEndpoint("events/" + eventId + "/prices");

      Api()
        .get(endpoint, {
          params: { page: this.currentPage, perPage: this.perPage }
        })
        .then(response => {
          if (typeof successCallback == "function") {
            successCallback(response.data.data);
          }
        });
    },

    openAddCustomerModal() {
      this.showAddCustomerModal = true;
    },

    closeAddCustomerModal() {
      this.showAddCustomerModal = false;
    },

    onSelectCustomer(customer) {
      this.showAddCustomerModal = false;
      this.selectedBooking.customer = {
        id: customer.id,
        name: `${customer.last_name} ${customer.first_name}`
      };
      this.customers = [this.selectedBooking.customer];
    }
  }
};
</script>

<style scoped>
.mr-1 {
  margin-right: 1rem;
}

.mb-4 {
  margin-bottom: 1.2rem;
}

.mt-8 {
  margin-top: 1.3rem;
}

.user-plus-button {
  padding: 0 1.5rem;
  font-size: 2rem;
  height: 40px;
}
</style>
